import React from "react";

// Numbered pagination with ellipses, matching the rankings design. Keeps the
// first and last page always reachable and a window around the current one.
const pagesToShow = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);

  if (start > 2) pages.push("…");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push("…");
  pages.push(total);

  return pages;
};

const Pagination = ({ page, totalPages, onChange, className = "" }) => {
  if (!totalPages || totalPages <= 1) return null;

  const arrow =
    "flex h-9 w-9 items-center justify-center rounded-sm border border-border text-muted transition-colors hover:bg-bg disabled:cursor-not-allowed disabled:opacity-40";

  return (
    <nav
      aria-label="Pagination"
      className={`flex items-center justify-center gap-1.5 ${className}`}
    >
      <button
        type="button"
        className={arrow}
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label="Previous page"
      >
        ‹
      </button>

      {pagesToShow(page, totalPages).map((entry, index) =>
        entry === "…" ? (
          <span key={`gap-${index}`} className="px-1 text-sm text-muted">
            …
          </span>
        ) : (
          <button
            key={entry}
            type="button"
            onClick={() => onChange(entry)}
            aria-current={entry === page ? "page" : undefined}
            className={`tabular h-9 min-w-9 rounded-sm px-3 text-sm font-semibold transition-colors ${
              entry === page
                ? "bg-primary text-white"
                : "border border-border text-navy hover:bg-bg"
            }`}
          >
            {entry}
          </button>
        )
      )}

      <button
        type="button"
        className={arrow}
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        aria-label="Next page"
      >
        ›
      </button>
    </nav>
  );
};

export default Pagination;
